import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function PriceBlock() {
  return <section id="pricing" className="py-24 bg-white relative" data-id="element-103">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-104">
        <FadeIn data-id="element-105">
          <div className="bg-cream rounded-3xl p-8 md:p-12 text-center border border-terracotta/20 shadow-2xl shadow-brown/5 relative overflow-hidden" data-id="element-106">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-32 h-32 bg-terracotta/5 rounded-br-full" data-id="element-107"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-sage/10 rounded-tl-full" data-id="element-108"></div>

            <div className="relative z-10" data-id="element-109">
              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6 font-serif" data-id="element-110">
                Recupera tu equilibrio emocional
              </h2>

              <p className="text-lg text-brown-light mb-10 max-w-2xl mx-auto" data-id="element-111">
                Obtén el mapa completo para entender a tu hijo por una fracción
                de lo que cuesta una sola consulta especializada.
              </p>

              <div className="mb-10" data-id="element-112">
                <span className="inline-block py-1.5 px-4 rounded-full bg-terracotta text-white text-sm font-bold tracking-wide mb-4" data-id="element-113">
                  🎉 Oferta Mes de las Madres — 68% de descuento
                </span>
                <span className="text-sm font-medium text-terracotta uppercase tracking-wider block mb-3" data-id="element-114">
                  Inversión Única
                </span>
                <div className="flex justify-center items-center gap-3 mb-2" data-id="element-115">
                  <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-116">
                    $19.97
                  </span>
                </div>
                <div className="flex justify-center items-start gap-1" data-id="element-117">
                  <span className="text-3xl font-bold text-green-600 mt-2" data-id="element-118">
                    $
                  </span>
                  <span className="text-7xl font-bold text-green-600 tracking-tighter" data-id="element-119">
                    6.36
                  </span>
                  <span className="text-xl font-medium text-green-600/70 mt-8" data-id="element-120">
                    USD
                  </span>
                </div>
              </div>

              <a href="https://casaconsciente.com/cart/47592671740134:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: 'Sintonía Total - El Manual de Conexión',
                  content_type: 'product',
                  value: 6.36,
                  currency: 'USD'
                });
              }
            }} className="inline-block w-full sm:w-auto px-10 py-5 bg-terracotta hover:bg-terracotta-dark text-white rounded-full font-bold text-xl transition-all duration-300 shadow-xl shadow-terracotta/30 hover:shadow-terracotta/40 hover:-translate-y-1 mb-6" data-id="element-121">
                Quiero el Manual Sintonía Total Ahora
              </a>

              <p className="text-brown-light font-medium" data-id="element-122">
                Acceso inmediato a todas las guías y guiones de rescate.
              </p>

              <div className="mt-8 flex items-center justify-center gap-2 text-sm text-brown-light/70" data-id="element-123">
                <ShieldCheck className="w-5 h-5 text-sage" data-id="element-124" />
                <span data-id="element-125">Pago 100% seguro y garantizado</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}